export default __webpack_public_path__ + "static/media/home_background_image.fd1ced56.png";